import type { AlphaDesignVersionsResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getAlphaDesignVersions } from "../api/alphaEditor.api";

const POLLING_INTERVAL_MS = 5000;

export function alphaDesignVersionsKey(
  requestId: number,
  designId: string,
): readonly ["alpha-design-versions", number, string] {
  return ["alpha-design-versions", requestId, designId] as const;
}

export function useAlphaDesignVersionsQuery(
  requestId: number,
  designId: string,
): UseQueryResult<AlphaDesignVersionsResponse> {
  return useQuery({
    queryFn: () => getAlphaDesignVersions(requestId, designId),
    queryKey: alphaDesignVersionsKey(requestId, designId),
    refetchInterval: (query) =>
      query.state.data?.versions.some(({ status }) => status === "generating")
        ? POLLING_INTERVAL_MS
        : false,
  });
}
